export const toastAutoHideDuration = 2000;
